module.exports = __webpack_public_path__ + "static/media/equipment.057060a7.jpg";